function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("path", {
  id: "Micro_svg__a",
  d: "M5 5H0V0h5v5h5v5H5z"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4 4)",
  fill: "none",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "Micro_svg__b",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#Micro_svg__a"
})),
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#Micro_svg__b)",
  fill: "currentColor"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M5 .5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 2a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
})));

var SvgMicro = function SvgMicro(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18,
      height: 18
    }, props), _ref, _ref2)
  );
};

export default SvgMicro;